<template>
  <PerfectScrollbar class="gp-main-body-content pricing">
    <div class="exit-btn" @click="exitUpgrade">
      <i class="icon icon-cancel"></i>
    </div>
    <!-- <div class="container fixed-container">
      <div class="row justify-content-center">
        <div class="agency-plan d-flex col-12 col-md-10 align-items-center px-3 py-2">
          <p class="typo-paragraph16 typo-regular text-light-high" v-html="$t('pricing.agencyPlan')"></p>
        </div>
      </div>
    </div> -->

    <section class="header container justify-content-center d-block mb-2 pb-1 mb-sm-3 pb-sm-1 mb-md-6 pb-md-0">
      <h1 class="txt-primary-300 text-center pricing__title">{{ $t("pricing.mainTitle") }}</h1>
      <p class="text-center txt-dark-low-contrast heading-h3-20-semi mt-1 mt-md-2" v-html="$t('pricing.subTitle2')"></p>
      <div class="row justify-content-center mt-6">
        <div class="col-4 col-md-2 d-flex flex-column align-items-center text-center px-0 px-md-1">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.4242 5.3723L15.4125 0.0988643C15.1109 -0.0335576 14.7676 -0.0329131 14.4664 0.100563L2.57191 5.374C2.14822 5.56185 1.875 5.98179 1.875 6.44533V15.7031C1.875 19.2019 3.25764 22.7785 5.66842 25.5157C6.88102 26.8926 8.27895 27.982 9.82342 28.754C11.4778 29.5808 13.2194 30 15 30C17.4933 30 19.9199 29.193 22.0177 27.6663C22.541 27.2854 22.6565 26.5525 22.2756 26.0292C21.8948 25.5059 21.1618 25.3904 20.6385 25.7712C18.9441 27.0044 16.9944 27.6563 15 27.6563C9.35748 27.6563 4.21875 21.959 4.21875 15.7031V7.20763L14.9437 2.45275L25.7812 7.21068V15.7031C25.7812 17.8611 25.1613 20.0449 23.9885 22.0185C23.6578 22.5749 23.8408 23.294 24.3972 23.6246C24.9537 23.9553 25.6727 23.7723 26.0033 23.2159C27.3913 20.8801 28.125 18.2823 28.125 15.7031V6.44533C28.125 5.98033 27.85 5.55927 27.4242 5.3723Z" fill="#F09621" />
            <path d="M20.589 9.22855L13.323 18.3075L9.2499 14.3897C8.78344 13.941 8.04158 13.9554 7.59293 14.4218C7.14428 14.8883 7.15863 15.6302 7.6251 16.0788L11.7551 20.0513C11.7567 20.0529 11.7584 20.0545 11.7601 20.0562C12.1877 20.4627 12.7413 20.6835 13.3277 20.6835C13.3591 20.6835 13.3906 20.6829 13.4221 20.6816C14.0433 20.6566 14.6138 20.3877 15.0285 19.9246C15.0429 19.9085 15.0568 19.892 15.0704 19.8751L22.4189 10.693C22.8233 10.1877 22.7415 9.45021 22.2362 9.0458C21.7308 8.64138 20.9934 8.72318 20.589 9.22855Z" fill="#F09621" />
          </svg>

          <p class="heading-h5-16-semi txt-dark-low-contrast mt-1">{{ $t("pricing.riskFree") }}</p>
        </div>
        <div class="col-4 col-md-2 d-flex flex-column align-items-center text-center px-0 px-md-1">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.6177 25.9678L26.6378 22.9879L29.6177 20.0079C30.0754 19.5503 30.0753 18.8083 29.6177 18.3506C29.1601 17.8929 28.4181 17.8929 27.9605 18.3506L24.9805 21.3306L22.0005 18.3506C21.5429 17.893 20.8009 17.893 20.3433 18.3506C19.8856 18.8083 19.8856 19.5503 20.3433 20.008L23.3232 22.9879L20.3433 25.9679C19.8856 26.4255 19.8856 27.1675 20.3433 27.6252C20.5721 27.854 20.8719 27.9684 21.1719 27.9684C21.4718 27.9684 21.7717 27.854 22.0005 27.6252L24.9805 24.6452L27.9605 27.6252C28.1893 27.854 28.4891 27.9684 28.7891 27.9684C29.089 27.9684 29.3889 27.854 29.6177 27.6251C30.0754 27.1675 30.0754 26.4255 29.6177 25.9678Z" fill="#F09621" />
            <path d="M25.3125 3H4.6875C2.10281 3 0 5.10281 0 7.6875V20.3438C0 22.9284 2.10281 25.0312 4.6875 25.0312H12.4805C13.1277 25.0312 13.6523 24.5066 13.6523 23.8594C13.6523 23.2121 13.1277 22.6875 12.4805 22.6875H4.6875C3.39516 22.6875 2.34375 21.6361 2.34375 20.3438V11.5618H27.6562V13.9055C27.6562 14.5528 28.1809 15.0774 28.8281 15.0774C29.4754 15.0774 30 14.5528 30 13.9055V7.6875C30 5.10281 27.8972 3 25.3125 3ZM27.6562 9.21803H2.34375V7.6875C2.34375 6.39516 3.39516 5.34375 4.6875 5.34375H25.3125C26.6048 5.34375 27.6562 6.39516 27.6562 7.6875V9.21803Z" fill="#F09621" />
            <path d="M6.4502 16.1001C7.14055 16.1001 7.7002 15.5405 7.7002 14.8501C7.7002 14.1597 7.14055 13.6001 6.4502 13.6001C5.75984 13.6001 5.2002 14.1597 5.2002 14.8501C5.2002 15.5405 5.75984 16.1001 6.4502 16.1001Z" fill="#F09621" />
            <path d="M11.25 16.1001C11.9404 16.1001 12.5 15.5405 12.5 14.8501C12.5 14.1597 11.9404 13.6001 11.25 13.6001C10.5596 13.6001 10 14.1597 10 14.8501C10 15.5405 10.5596 16.1001 11.25 16.1001Z" fill="#F09621" />
            <path d="M16.0498 16.1001C16.7402 16.1001 17.2998 15.5405 17.2998 14.8501C17.2998 14.1597 16.7402 13.6001 16.0498 13.6001C15.3594 13.6001 14.7998 14.1597 14.7998 14.8501C14.7998 15.5405 15.3594 16.1001 16.0498 16.1001Z" fill="#F09621" />
            <path d="M20.8496 16.1001C21.54 16.1001 22.0996 15.5405 22.0996 14.8501C22.0996 14.1597 21.54 13.6001 20.8496 13.6001C20.1593 13.6001 19.5996 14.1597 19.5996 14.8501C19.5996 15.5405 20.1593 16.1001 20.8496 16.1001Z" fill="#F09621" />
          </svg>
          <p class="heading-h5-16-semi txt-dark-low-contrast mt-1">{{ $t("pricing.noCredit") }}</p>
        </div>
        <div class="col-4 col-md-2 d-flex flex-column align-items-center text-center px-0 px-md-1">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.3516 21.4453C15.9988 21.4453 16.5234 20.9206 16.5234 20.2734C16.5234 19.6262 15.9988 19.1016 15.3516 19.1016C14.7044 19.1016 14.1797 19.6262 14.1797 20.2734C14.1797 20.9206 14.7044 21.4453 15.3516 21.4453Z" fill="#F09621" />
            <path d="M16.5234 27.6562H4.6875C3.39516 27.6562 2.34375 26.6048 2.34375 25.3125V15.7031C2.34375 14.4108 3.39516 13.3594 4.6875 13.3594H21.5625C22.8548 13.3594 23.9062 14.4108 23.9062 15.7031V18.2812C23.9062 18.9285 24.4309 19.4531 25.0781 19.4531C25.7254 19.4531 26.25 18.9285 26.25 18.2812V15.7031C26.25 13.1184 24.1472 11.0156 21.5625 11.0156H20.1541V6.88277C20.1541 3.0876 16.9999 0 13.1228 0C9.2458 0 6.09158 3.0876 6.09158 6.88277V11.0156H4.6875C2.10281 11.0156 0 13.1184 0 15.7031V25.3125C0 27.8972 2.10281 30 4.6875 30H16.5234C17.1707 30 17.6953 29.4754 17.6953 28.8281C17.6953 28.1809 17.1707 27.6562 16.5234 27.6562ZM8.43533 6.88277C8.43533 4.37994 10.5381 2.34375 13.1228 2.34375C15.7075 2.34375 17.8103 4.37994 17.8103 6.88277V11.0156H8.43533V6.88277Z" fill="#F09621" />
            <path d="M10.957 21.4453C11.6042 21.4453 12.1289 20.9206 12.1289 20.2734C12.1289 19.6262 11.6042 19.1016 10.957 19.1016C10.3098 19.1016 9.78516 19.6262 9.78516 20.2734C9.78516 20.9206 10.3098 21.4453 10.957 21.4453Z" fill="#F09621" />
            <path d="M29.6565 27.9995L26.6766 25.0196L29.6565 22.0396C30.1142 21.582 30.1142 20.84 29.6565 20.3823C29.1989 19.9246 28.457 19.9246 27.9993 20.3823L25.0193 23.3623L22.0393 20.3824C21.5817 19.9247 20.8398 19.9248 20.3821 20.3824C19.9244 20.84 19.9244 21.582 20.3821 22.0397L23.362 25.0196L20.3821 27.9996C19.9244 28.4572 19.9244 29.1992 20.3821 29.6569C20.6109 29.8857 20.9108 30.0001 21.2107 30.0001C21.5107 30.0001 21.8105 29.8857 22.0393 29.6569L25.0193 26.6769L27.9993 29.6569C28.2281 29.8857 28.528 30.0001 28.8279 30.0001C29.1278 30.0001 29.4277 29.8857 29.6565 29.6569C30.1142 29.1992 30.1142 28.4572 29.6565 27.9995Z" fill="#F09621" />
            <path d="M6.5625 21.4453C7.20971 21.4453 7.73438 20.9206 7.73438 20.2734C7.73438 19.6262 7.20971 19.1016 6.5625 19.1016C5.91529 19.1016 5.39062 19.6262 5.39062 20.2734C5.39062 20.9206 5.91529 21.4453 6.5625 21.4453Z" fill="#F09621" />
          </svg>

          <p class="heading-h5-16-semi txt-dark-low-contrast mt-1">{{ $t("pricing.noObligation") }}</p>
        </div>
      </div>
      <!-- <p class="typo-heading18 typo-semibold typo-lh150 text-center mt-1">{{ $t("pricing.subTitle") }}</p> -->
      <div class="annoucement" v-if="announcement">
        <div class="annoucement__wrapper">
          <div class="annoucement__text typo-heading18 typo-semibold">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="annoucement__icon">
              <path d="M19.5591 28.7775L27.2561 27.1125C27.2561 27.1125 24.4785 8.32528 24.4561 8.20048C24.4369 8.07675 24.3345 7.99568 24.2311 7.99568C24.1276 7.99568 22.1735 7.85062 22.1735 7.85062C22.1735 7.85062 20.8135 6.49168 20.6385 6.34555C20.5905 6.30608 20.5585 6.28475 20.5095 6.26662L19.5345 28.7775H19.5591ZM15.6903 15.2586C15.6903 15.2586 14.8263 14.8063 13.798 14.8063C12.2545 14.8063 12.1937 15.7728 12.1937 16.0234C12.1937 17.3376 15.6497 17.8527 15.6497 20.961C15.6497 23.409 14.1137 24.9717 12.0167 24.9717C9.50574 24.9717 8.24067 23.409 8.24067 23.409L8.92974 21.184C8.92974 21.184 10.2577 22.321 11.3617 22.321C12.0817 22.321 12.4017 21.7397 12.4017 21.3269C12.4017 19.5999 9.57081 19.52 9.57081 16.6773C9.53454 14.2912 11.2465 11.9669 14.7196 11.9669C16.0604 11.9669 16.7196 12.352 16.7196 12.352L15.7116 15.248L15.6903 15.2586ZM15.1143 4.08528C15.2593 4.08528 15.4033 4.12582 15.5463 4.22928C14.4967 4.72528 13.3447 5.97755 12.8711 8.48742C12.1713 8.71462 11.4919 8.91942 10.8561 9.10395C11.4097 7.19995 12.7473 4.09595 15.1143 4.09595V4.08528ZM16.4316 7.23088V7.37488C15.6273 7.62235 14.7431 7.89115 13.878 8.15995C14.3751 6.26448 15.2999 5.33862 16.102 4.99088C16.3079 5.52528 16.4316 6.24528 16.4316 7.23088ZM17.0065 4.84795C17.7468 4.92688 18.2236 5.77275 18.5308 6.71995C18.1585 6.84155 17.7468 6.96635 17.2956 7.11035V6.84155C17.2956 6.03942 17.1932 5.37915 17.0065 4.84582V4.84795ZM20.198 6.22288C20.1767 6.22288 20.134 6.24528 20.1148 6.24528C20.0956 6.24528 19.8065 6.32528 19.3532 6.46928C18.902 5.15408 18.0988 3.94128 16.678 3.94128H16.5553C16.1436 3.42288 15.6465 3.19995 15.2156 3.19995C11.9025 3.19995 10.3196 7.33542 9.82361 9.43568C8.55001 9.82502 7.62307 10.1141 7.51961 10.1546C6.79961 10.3818 6.77934 10.4021 6.69614 11.0826C6.61614 11.5754 4.74414 26.0831 4.74414 26.0831L19.2092 28.7999L20.198 6.22288Z" fill="#5E8E3E" />
              <path d="M15.6903 15.2586C15.6903 15.2586 14.8263 14.8063 13.798 14.8063C12.2545 14.8063 12.1937 15.7728 12.1937 16.0234C12.1937 17.3376 15.6497 17.8527 15.6497 20.961C15.6497 23.409 14.1137 24.9717 12.0167 24.9717C9.50574 24.9717 8.24067 23.409 8.24067 23.409L8.92974 21.184C8.92974 21.184 10.2577 22.321 11.3617 22.321C12.0817 22.321 12.4017 21.7397 12.4017 21.3269C12.4017 19.5999 9.57081 19.52 9.57081 16.6773C9.53454 14.2912 11.2465 11.9669 14.7196 11.9669C16.0604 11.9669 16.7196 12.352 16.7196 12.352L15.7116 15.248L15.6903 15.2586ZM15.1143 4.08528C15.2593 4.08528 15.4033 4.12582 15.5463 4.22928C14.4967 4.72528 13.3447 5.97755 12.8711 8.48742C12.1713 8.71462 11.4919 8.91942 10.8561 9.10395C11.4097 7.19995 12.7473 4.09595 15.1143 4.09595V4.08528ZM16.4316 7.23088V7.37488C15.6273 7.62235 14.7431 7.89115 13.878 8.15995C14.3751 6.26448 15.2999 5.33862 16.102 4.99088C16.3079 5.52528 16.4316 6.24528 16.4316 7.23088ZM17.0065 4.84795C17.7468 4.92688 18.2236 5.77275 18.5308 6.71995C18.1585 6.84155 17.7468 6.96635 17.2956 7.11035V6.84155C17.2956 6.03942 17.1932 5.37915 17.0065 4.84582V4.84795ZM20.198 6.22288C20.1767 6.22288 20.134 6.24528 20.1148 6.24528C20.0956 6.24528 19.8065 6.32528 19.3532 6.46928C18.902 5.15408 18.0988 3.94128 16.678 3.94128H16.5553C16.1436 3.42288 15.6465 3.19995 15.2156 3.19995C11.9025 3.19995 10.3196 7.33542 9.82361 9.43568C8.55001 9.82502 7.62307 10.1141 7.51961 10.1546C6.79961 10.3818 6.77934 10.4021 6.69614 11.0826C6.61614 11.5754 4.74414 26.0831 4.74414 26.0831L19.2092 28.7999L20.198 6.22288Z" fill="#95BF47" />
            </svg>
            {{ announcement }}
          </div>
        </div>
      </div>
    </section>

    <div class="container mb-3" v-if="hasAnyDiscount">
      <div class="row justify-content-center">
        <div class="d-flex col-12 col-sm-10 col-md-8 col-lg-6 col-mlg-5 col-xl-4 align-items-center justify-content-center">
          <!-- <p class="typo-paragraph16 typo-regular text-light-high" v-html="$t('pricing.discountApplied', { amount: `${discount.discount}${discount.unit}` })"></p> -->
          <div v-if="discount && !isShowBusinessDiscount" class="promotion-applied px-2 px-sm-3">
            <p class="d-flex align-items-center typo-paragraph16 typo-regular text-light">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 4.35354L6 13.0607L1.29289 8.35354L2.70711 6.93933L6 10.2322L13.2929 2.93933L14.7071 4.35354Z" fill="#06E884" />
              </svg>

              <span class="mx-1" v-html="$t('pricing.discountApplied', { amount: `${discount.discount}${discount.unit}`, code: discount.code })"></span>
              <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path d="M3.50799 11L4.77087 13.3721L7.01599 14.6279L4.77087 15.8837L3.50799 18.1163L2.24512 15.8837L0 14.6279L2.24512 13.3721L3.50799 11Z" fill="#FFBB1C" />
                  <path d="M13.1563 0L15.8224 4.60465L20.4529 7.11628L15.8224 9.62791L13.1563 14.2326L10.6305 9.62791L6 7.11628L10.6305 4.60465L13.1563 0Z" fill="#FFBB1C" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="21" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container" :class="{ 'mt-lg-5': isShowBusinessDiscount }">
      <section class="plans">
        <div class="row justify-content-center">
          <div class="plan starter pt-lg-3 col-lg-4 pl-lg-0">
            <div class="plan-header">
              <div class="gem">
                <img :src="publicPath + require('@/core/assets/pricing/gem.svg')" />
              </div>
              <div class="describe">
                <div class="info">
                  <h2 class="heading-h2-24-semi txt-dark-high-contrast">{{ $t("pricing.starter") }}</h2>
                  <p class="balancer paragraph-14-medium txt-dark-low-contrast" v-html="$t('pricing.starterDescription')"></p>
                </div>

                <div class="plan-price mt-3 flex-column">
                  <span class="old-price" v-if="applyDiscountFor.starter"> <span class="heading-h2-24-semi">$</span>{{ starterPrice }}</span>
                  <div>
                    <span class="amount txt-dark-low-contrast"> <span class="dollar">$</span>{{ starterPrice * rate }}</span>
                    <!-- <span class="amount txt-dark-low-contrast" v-if="!(applyDiscount(starterPrice) && applyDiscountFor.starter)"> <span class="heading-h2-24-semi">$</span>{{ starterPrice * rate }}</span> -->
                    <!-- <span class="amount txt-dark-low-contrast" v-else> <span class="heading-h2-24-semi">$</span>{{ getDiscountPrice(starterPrice) }}</span> -->
                    <span class="billing-period paragraph-14-medium txt-dark-low-contrast">{{ $t("pricing.perMonth") }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="features">
              <div class="feature-container pt-3 pb-4">
                <template v-if="isDevStore">
                  <a class="disabled cursor-default btn btn-border-grey text-upper paragraph-14-medium mb-4" v-popover:tooltip.bottom="$t('pricing.devDisableTooltip')">{{ $t("pricing.devDisableButtonText") }} </a>
                </template>
                <template v-else>
                  <a :href="paymentLink('starter')" v-if="plan != 'starter'" class="btn btn-border-grey text-upper paragraph-14-medium mb-4">{{ $t("pricing.choosePlan") }} </a>

                  <a v-else class="btn btn-border-grey text-upper paragraph-14-medium mb-4 disabled">{{ $t("pricing.currentPlan") }}</a>
                </template>

                <!-- <p class="see-features" @click="activeStarter = !activeStarter">See plan features</p> -->

                <ul class="list pb-4" :class="{ active: activeStarter }">
                  <PLanPackItem  v-for="(item, ind) in starterPack" :key="'starter_' + ind" :item="item" />
                </ul>

                <template v-if="isDevStore">
                  <a class="disabled cursor-default btn btn-border-grey text-upper paragraph-14-medium" v-popover:tooltip.bottom="$t('pricing.devDisableTooltip')">{{ $t("pricing.devDisableButtonText") }} </a>
                </template>
                <template v-else>
                  <a :href="paymentLink('starter')" v-if="plan != 'starter'" class="btn btn-border-grey text-upper paragraph-14-medium">{{ $t("pricing.choosePlan") }} </a>
                  <a v-else class="btn btn-border-grey text-upper paragraph-14-medium disabled">{{ $t("pricing.currentPlan") }}</a>
                </template>
              </div>
            </div>

            <!-- <div class="color-bar color-bar--starter"></div> -->
          </div>

          <div class="plan professional col-lg-4 mt-lg-0" :class="{ 'mt-6 pt-5 pt-lg-0': isShowBusinessDiscount, 'mt-2 mt-sm-6': !isShowBusinessDiscount }">
            <div class="plan-header pt-6" :class="{ 'plan-discount': isShowBusinessDiscount }">
              <div class="d-flex justify-content-center mb-3 plan-discount__box plan-discount--professional" v-if="isShowBusinessDiscount">
                <div class="d-flex align-items-center bg-primary-300 bg-primary-200-hover border-radius px-3 py-1 plan-discount__wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.36634 15.0641C9.28824 15.1422 9.1616 15.1422 9.0835 15.0641L5.92314 11.9037C5.72788 11.7085 5.41129 11.7085 5.21603 11.9037L4.35355 12.7662C4.15829 12.9615 4.15829 13.278 4.35355 13.4733L8.51781 17.6376C8.90834 18.0281 9.5415 18.0281 9.93203 17.6376L19.6464 7.92314C19.8417 7.72788 19.8417 7.41129 19.6464 7.21603L18.784 6.35355C18.5887 6.15829 18.2721 6.15829 18.0769 6.35355L9.36634 15.0641Z" fill="#00C753" />
                  </svg>

                  <span class="txt-light-grey-600 heading-16-medium mr-4px ml-1">{{ $t("pricing.promotionCodeApplied") }}</span>

                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.50799 14L6.77087 16.3721L9.01599 17.6279L6.77087 18.8837L5.50799 21.1163L4.24512 18.8837L2 17.6279L4.24512 16.3721L5.50799 14Z" fill="#FFBB1C" />
                    <path d="M15.1563 3L17.8224 7.60465L22.4529 10.1163L17.8224 12.6279L15.1563 17.2326L12.6305 12.6279L8 10.1163L12.6305 7.60465L15.1563 3Z" fill="#FFBB1C" />
                  </svg>
                </div>
              </div>
              <div class="gem">
                <img :src="publicPath + require('@/core/assets/pricing/diamond.svg')" />
              </div>
              <div class="describe">
                <div class="info txt-light-high-contrast">
                  <h2 class="heading-h2-24-semi">{{ $t("pricing.business") }}</h2>
                  <p class="balancer body-14-medium" v-html="$t('pricing.businessDescription')"></p>
                  <div class="riboon"></div>
                </div>

                <div class="plan-price flex-column" :class="{ 'mt-2': applyDiscountFor.professional || isShowBusinessDiscount, 'mt-3': !(applyDiscountFor.professional || isShowBusinessDiscount) }">
                  <span class="old-price old-price-professional" v-if="applyDiscountFor.professional || isShowBusinessDiscount"> <span class="heading-h2-24-semi">$</span>{{ professionalPrice }}</span>
                  <div>
                    <span class="amount txt-light-high-contrast"> <span class="heading-h2-24-semi">$</span>{{ getPriceForPlan("professional") }}</span>
                    <!-- <span class="amount txt-light-high-contrast" v-if="!(applyDiscount(professionalPrice) && applyDiscountFor.professional)"> <span class="heading-h2-24-semi">$</span>{{ professionalPrice * rate }}</span> -->
                    <!-- <span class="amount txt-light-high-contrast" v-else> <span class="heading-h2-24-semi">$</span>{{ getDiscountPrice(professionalPrice) }}</span> -->
                    <span class="billing-period paragraph-14-medium txt-light-high-contrast">{{ $t("pricing.perMonth") }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="features">
              <div class="feature-container pt-3 pb-4">
                <a :href="paymentLink('professional')" @click="clearCookie" v-if="plan != 'professional'" class="btn text-upper btn-solid-blue mb-4 paragraph-14-medium">{{ $t("pricing.choosePlan") }}</a>

                <a v-else class="btn text-upper btn-solid-blue mb-4 paragraph-14-medium disabled" disabled>{{ $t("pricing.currentPlan") }}</a>

                <p class="paragraph-14-bold txt-dark-high-contrast mb-2">
                  <span class="main-text">{{ $t("pricing.everythingStarter") }}</span>
                </p>
                <ul class="list typo-body2 pb-4" :class="{ active: activeProfessional }">
                  <PLanPackItem  v-for="(item, ind) in professionalPack" :key="'professional_' + ind" :item="item" />
                </ul>

                <a :href="paymentLink('professional')" @click="clearCookie" v-if="plan != 'professional'" class="btn paragraph-14-medium text-upper btn-solid-blue mb-2">{{ $t("pricing.choosePlan") }}</a>
                <a v-else class="btn paragraph-14-medium text-upper btn-solid-blue disabled mb-2" disabled>{{ $t("pricing.currentPlan") }}</a>
              </div>
            </div>

            <!-- <div class="color-bar color-bar--starter"></div> -->
          </div>

          <div class="plan advanced pt-lg-3 col-lg-4 pr-lg-0 mt-4 mt-lg-0 mt-sm-6 mt-lg-0">
            <div class="plan-header" :class="{ 'plan-discount': isShowAdvandDiscount }">
              <div class="d-flex align-items-center paragraph-14-medium plan-discount__box plan-discount--advanced text-center" v-if="isShowAdvandDiscount">
                <span class="txt-light-grey-600 bg-accent-amber-300 plan-discount--advanced__first">
                  {{ $t("pricing.limitedOffer") }}
                </span>
                <div class="txt-dark-high-contrast plan-discount--advanced__last">
                  {{ $t("pricing.advancedDiscount2021") }}
                </div>
              </div>

              <div class="gem">
                <img :src="publicPath + require('@/core/assets/pricing/crown.svg')" />
              </div>
              <div class="describe">
                <div class="info">
                  <h2 class="heading-h2-24-semi txt-dark-high-contrast">{{ $t("pricing.advanced") }}</h2>
                  <p class="balancer paragraph-14-medium txt-dark-low-contrast" v-html="$t('pricing.advancedDescription')"></p>
                </div>

                <div class="plan-price flex-column" :class="{ 'mt-2': isShowAdvandDiscount, 'mt-3': !isShowAdvandDiscount }">
                  <span class="old-price" v-if="applyDiscountFor.advanced"> <span class="heading-h2-24-semi">$</span>{{ advancedPrice }}</span>
                  <span class="old-price" v-else-if="isShowAdvandDiscount"> <span class="heading-h2-24-semi">$</span>{{ advancedPrice }}</span>
                  <div>
                    <span class="amount txt-dark-low-contrast"> <span class="heading-h2-24-semi">$</span>{{ getPriceForPlan("advanced") }}</span>
                    <!-- <span class="amount txt-dark-low-contrast" v-if="!(applyDiscount(advancedPrice) && applyDiscountFor.advanced)"> <span class="heading-h2-24-semi">$</span>{{ advancedPrice * rate }}</span> -->
                    <!-- <span class="amount txt-dark-low-contrast" v-else> <span class="heading-h2-24-semi">$</span>{{ getDiscountPrice(advancedPrice) }}</span> -->
                    <span class="billing-period paragraph-14-medium txt-dark-low-contrast">{{ $t("pricing.perMonth") }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="features">
              <div class="feature-container pt-3 pb-4">
                <template v-if="isDevStore">
                  <a v-if="plan != 'advanced'" class="disabled cursor-default btn btn-border-grey text-upper paragraph-14-medium mb-4" v-popover:tooltip.bottom="$t('pricing.devDisableTooltip')">{{ $t("pricing.devDisableButtonText") }} </a>
                </template>
                <template v-else>
                  <a :href="paymentLink('advanced')" @click="clearCookie" v-if="plan != 'advanced'" class="btn btn-border-grey text-upper paragraph-14-medium mb-4">{{ $t("pricing.choosePlan") }} </a>

                  <a v-else class="btn btn-border-grey text-upper paragraph-14-medium mb-4 disabled">{{ $t("pricing.currentPlan") }}</a>
                </template>

                <ul class="list typo-body2 pb-4" :class="{ active: activeAdvanced }">
                  <p class="paragraph-14-bold txt-dark-high-contrast mb-2">
                    <span class="main-text">{{ $t("pricing.everythingBusiness") }}</span>
                  </p>
                  <PLanPackItem v-for="(item, ind) in advancedPack" :key="'advanced_' + ind" :item="item" />
                </ul>

                <template v-if="isDevStore">
                  <a v-if="plan != 'advanced'" class="disabled cursor-default btn btn-border-grey text-upper paragraph-14-medium" v-popover:tooltip.bottom="$t('pricing.devDisableTooltip')">{{ $t("pricing.devDisableButtonText") }} </a>
                </template>
                <template v-else>
                  <a :href="paymentLink('advanced')" @click="clearCookie" v-if="plan != 'advanced'" class="btn btn-border-grey text-upper paragraph-14-medium" :class="isDevStore ? 'disabled no-hover' : ''">{{ $t("pricing.choosePlan") }} </a>
                  <a v-else class="btn btn-border-grey text-upper paragraph-14-medium disabled">{{ $t("pricing.currentPlan") }}</a>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-6 border-radius request">
          <div class="col-12 col-lg-4 bg-light-grey-500 px-4 py-3 request__left">
            <div class="d-block d-md-none heading-h2-24-semi txt-dark-blue-100" v-html="$t('pricing.requestTitle')"></div>
            <div class="d-none d-md-block heading-h2-24-semi txt-dark-blue-100" v-html="$t('pricing.requestTitle2')"></div>
            <div class="d-none d-md-block body-14-regular txt-dark-low-contrast" v-html="$t('pricing.requestTitle')"></div>
          </div>
          <div class="col-12 col-lg-8 d-flex justify-content-between align-items-center px-lg-4 py-2 py-lg-0 flex-wrap request__right">
            <div class="mb-4 mb-lg-0">
              <p class="txt-dark-low-contrast request__text">
                <i class="icon icon-arrow-right mr-12px"></i>
                <span>{{ $t("pricing.requestDesc1Left") }}</span>
                <span class="txt-accent-red-300 ml-4px">{{ $t("pricing.requestDesc1Right") }}</span>
              </p>
              <p class="txt-dark-low-contrast request__text">
                <i class="icon icon-arrow-right mr-12px"></i>
                <span>{{ $t("pricing.requestDesc2Left") }}</span>
                <span class="txt-accent-red-300 ml-4px">{{ $t("pricing.requestDesc2Right") }}</span>
              </p>
            </div>

            <a target="_blank" :href="pricingRequestLink" class="d-flex justify-content-center bg-primary-300 bg-primary-200-hover clickable px-6 py-12px border-radius txt-light-grey-600 request__make">
              <span class="paragraph-14-medium">{{ $t("pricing.requestMake") }}</span>
              <i class="d-inline d-md-none ml-12px icon icon-arrow-right heading-16-medium"></i>
            </a>
          </div>
        </div>

        <div class="col-12 d-flex flex-column align-items-center justify-content-center mt-2 mt-md-6 pt-0 pt-md-5">
          <div class="stars mb-1">
            <span class="star" v-for="i in 5" :key="i" :class="{ medium: [2, 4].includes(i), big: i == 3 }">
              <svg width="36" height="36" viewBox="0 0 12 12" fill="none">
                <path d="M11.7776 4.36449C11.7242 4.22099 11.6283 4.0972 11.5027 4.00965C11.3771 3.9221 11.2277 3.87494 11.0746 3.87449H8.03112C7.97933 3.87453 7.92881 3.85848 7.88654 3.82856C7.84426 3.79865 7.81232 3.75634 7.79512 3.70749L6.70262 0.610991C6.64911 0.467871 6.55316 0.344511 6.42762 0.257419C6.30207 0.170326 6.15292 0.123657 6.00012 0.123657C5.84733 0.123657 5.69818 0.170326 5.57263 0.257419C5.44709 0.344511 5.35114 0.467871 5.29762 0.610991L5.29512 0.618991L4.20512 3.70749C4.18796 3.75626 4.15609 3.79851 4.11392 3.82842C4.07174 3.85833 4.02133 3.87442 3.96962 3.87449H0.925125C0.771033 3.87437 0.620646 3.92172 0.494416 4.0101C0.368187 4.09847 0.272242 4.22359 0.21963 4.36842C0.167019 4.51325 0.160295 4.67077 0.200373 4.81956C0.240451 4.96835 0.325385 5.10118 0.443625 5.19999L3.03562 7.34999C3.0744 7.38217 3.10254 7.4253 3.11637 7.47375C3.1302 7.5222 3.12907 7.5737 3.11312 7.62149L2.02412 10.887C1.9738 11.038 1.9728 11.2011 2.02129 11.3526C2.06977 11.5042 2.16522 11.6365 2.29382 11.7302C2.42243 11.824 2.57752 11.8744 2.73667 11.8742C2.89582 11.8739 3.05078 11.8231 3.17912 11.729L5.85212 9.76899C5.89499 9.73759 5.94674 9.72066 5.99987 9.72066C6.05301 9.72066 6.10476 9.73759 6.14762 9.76899L8.81962 11.7285C8.94792 11.8229 9.10294 11.874 9.26223 11.8745C9.42153 11.8749 9.57682 11.8246 9.70561 11.7308C9.8344 11.6371 9.92999 11.5048 9.97854 11.353C10.0271 11.2013 10.0261 11.0381 9.97563 10.887L8.88663 7.61949C8.87068 7.5717 8.86955 7.5202 8.88338 7.47175C8.89721 7.4233 8.92535 7.38017 8.96412 7.34799L11.5611 5.19499C11.6779 5.09534 11.7612 4.96228 11.7999 4.81377C11.8386 4.66526 11.8308 4.50844 11.7776 4.36449Z" fill="#F09621" />
              </svg>
            </span>
          </div>
          <p class="heading-h4-18-semi txt-dark-high-contrast text-upper text-center">{{ $t("pricing.moneybackGuarantee") }}</p>
          <p class="paragraph-14-regular txt-dark-low-contrast text-center mt-1">{{ $t("pricing.satisfied") }}</p>
        </div>

        <!-- <div class="py-2 py-md-3 py-lg-5"></div> -->

        <!-- <div class="col-8 m-auto">
          <div class="restricted-multi-stores">
            <p class="typo-paragraph16" v-html="$t('pricing.restricted')"></p>
          </div>
        </div> -->

        <div class="py-2 py-md-4"></div>
      </section>
    </div>

    <div class="container">
      <div class="gp-pricing-action" :class="{ 'mb-2': showTablePricing, 'mb-68 mb-md-none': isShowAdvandDiscount }">
        <div class="gp-pricing-action_section" @click="toggleTablePricing()">
          <button class="gp-pricing-action_section__button">{{ $t('dataPlan.plan.action') }}</button>
          <div class="gp-pricing-action_section__icon">
            <svg v-if="showTablePricing" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1631 13.087L16.8373 14.4128L10.0002 7.57572L3.16309 14.4128L1.83726 13.087L10.0002 4.92407L18.1631 13.087Z" fill="#1E232F" />
            </svg>
            <svg v-else width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.08301 7.08123L3.40883 5.7554L10.2459 12.5925L17.083 5.7554L18.4088 7.08123L10.2459 15.2441L2.08301 7.08123Z" fill="#1E232F" />
            </svg>
          </div>
        </div>
      </div>
      <div class="gp-pricing-table">
        <TablePricing v-if="showTablePricing" :dataPlan="dataPlan" :currentPlan="plan" :isDevStore="isDevStore" :paymentLink="paymentLink" :getPriceForPlan="getPriceForPlan" :isShowAdvandDiscount="isShowAdvandDiscount" :isShowBusinessDiscount="isShowBusinessDiscount"></TablePricing>
      </div>
    </div>

    <div class="container-fluid actual-fullwidth bg-light-grey-500">
      <div class="container mt-lg-5">
        <div class="py-2 py-md-3 py-lg-5"></div>
        <section class="testimonials row">
          <div class="header-review col-12 text-center justify-content-center align-items-center mb-2">
            <svg width="80" height="80" viewBox="0 0 20 20" fill="none" class="mr-1">
              <path d="M16.5783 3.901C16.5665 3.79493 16.4726 3.74779 16.4022 3.736C16.3318 3.72422 14.7943 3.61815 14.7943 3.61815C14.7943 3.61815 13.7262 2.55745 13.6206 2.4396C13.5032 2.32174 13.2802 2.3571 13.1863 2.38067C13.1746 2.38067 12.9516 2.45138 12.5877 2.56924C12.2474 1.5439 11.6136 0.601061 10.5103 0.601061H10.4164C10.0995 0.188568 9.71223 0 9.3836 0C6.81324 0.0117855 5.59261 3.22923 5.2053 4.86741C4.20767 5.17384 3.50346 5.39776 3.40957 5.42133C2.85794 5.59811 2.83447 5.6099 2.76405 6.14025C2.70536 6.55274 1.25 17.8668 1.25 17.8668L12.5995 20L18.7496 18.6682C18.7496 18.6565 16.59 4.00707 16.5783 3.901ZM11.9657 2.76959C11.684 2.86388 11.3554 2.95816 11.0033 3.06423V2.85209C11.0033 2.21567 10.9094 1.69711 10.7685 1.29641C11.3436 1.3789 11.731 2.02711 11.9657 2.76959ZM10.0761 1.42605C10.2286 1.82675 10.3343 2.39246 10.3343 3.15851V3.26458C9.71223 3.45315 9.0315 3.66529 8.35076 3.87743C8.73808 2.41603 9.45402 1.69711 10.0761 1.42605ZM9.31318 0.70713C9.41881 0.70713 9.53618 0.742487 9.64181 0.8132C8.82023 1.20212 7.93997 2.18032 7.5644 4.13671C7.0245 4.30171 6.48461 4.46671 5.99167 4.61992C6.43766 3.13494 7.4705 0.70713 9.31318 0.70713Z" fill="#95BF47" />
              <path d="M16.4028 3.73541C16.3324 3.72362 14.7949 3.61755 14.7949 3.61755C14.7949 3.61755 13.7268 2.55685 13.6212 2.439C13.5743 2.39186 13.5156 2.36829 13.4569 2.36829L12.6001 19.9994L18.7502 18.6676C18.7502 18.6676 16.5906 4.00647 16.5789 3.91219C16.5671 3.80612 16.4732 3.74719 16.4028 3.73541Z" fill="#5E8E3E" />
              <path d="M10.8579 6.61765L10.0947 8.88053C9.64267 8.65923 9.13492 8.53773 8.6161 8.52674C7.4181 8.52674 7.35763 9.28103 7.35763 9.46948C7.35763 10.5067 10.0457 10.8957 10.0457 13.3234C10.0457 15.233 8.83623 16.4586 7.21672 16.4586C6.65265 16.4607 6.09527 16.3526 5.5858 16.1425C5.07633 15.9323 4.62782 15.6254 4.27344 15.2445L4.78989 13.5123C4.78989 13.5123 5.8107 14.3947 6.67971 14.3947C6.79139 14.3905 6.90097 14.367 7.00198 14.3254C7.103 14.2839 7.19341 14.2252 7.26787 14.1528C7.34233 14.0805 7.39934 13.9959 7.43553 13.9041C7.47172 13.8123 7.48635 13.7151 7.47858 13.6184C7.47858 12.263 5.27247 12.2037 5.27247 9.98808C5.27247 8.12623 6.61017 6.31373 9.29825 6.31373C9.84075 6.29292 10.3798 6.39878 10.8591 6.62027L10.8579 6.61765Z" fill="white" />
            </svg>
            <h2 class="section-title txt-primary-300 text-center mt-2">{{ $t("pricing.whatCustomerSaying") }}</h2>
            <p class="paragraph-14-regular txt-dark-low-contrast mt-4px" v-html="$t('pricing.adaptedFromShopifi')"></p>
            <div class="paragraph-14-medium gempage-link" v-html="$t('pricing.gempagesLink')"></div>
          </div>

          <div class="col-12 video-review my-6">
            <div class="row justify-content-center">
              <div class="col-12 col-md-10 d-flex align-items-center">
                <div style="text-align: center " class="full-width">
                  <div class="wistia_responsive_padding" style="padding:56.0% 0 0 0;position:relative;">
                    <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
                      <div class="wistia_embed wistia_async_ofwzjjtqyc videoFoam=true" style="height:100%;width:100%">&nbsp;</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="testimonial-item col-lg-4 col-md-12 d-flex m-0">
                <div class="row">
                  <div class="testimonial p-3 pb-5">
                    <div class="avatar mb-1">
                      <img :src="`${publicPath}${firstTestimonial.avatar}`" alt />
                    </div>
                    <h5 class="typo-h4 text-secondary4 mb-1">{{ firstTestimonial.name }}</h5>
                    <div class="stars mb-1">
                      <span class="star mr-1" v-for="i in firstTestimonial.stars" :key="i">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.6292 7.27411C19.5402 7.03495 19.3803 6.82863 19.171 6.68271C18.9616 6.53679 18.7127 6.4582 18.4575 6.45744H13.385C13.2987 6.45751 13.2145 6.43076 13.1441 6.3809C13.0736 6.33104 13.0204 6.26053 12.9917 6.17911L11.1709 1.01828C11.0817 0.779745 10.9218 0.574144 10.7125 0.42899C10.5033 0.283836 10.2547 0.206055 10 0.206055C9.74538 0.206055 9.4968 0.283836 9.28756 0.42899C9.07831 0.574144 8.9184 0.779745 8.82921 1.01828L8.82504 1.03161L7.00838 6.17911C6.97977 6.2604 6.92666 6.33081 6.85637 6.38066C6.78607 6.43051 6.70205 6.45733 6.61588 6.45744H1.54171C1.28489 6.45725 1.03425 6.53617 0.823864 6.68346C0.613482 6.83075 0.453573 7.03927 0.365888 7.28066C0.278202 7.52204 0.266995 7.78458 0.333792 8.03256C0.400588 8.28054 0.542146 8.50192 0.739212 8.66661L5.05921 12.2499C5.12383 12.3036 5.17074 12.3755 5.19379 12.4562C5.21684 12.537 5.21495 12.6228 5.18838 12.7024L3.37338 18.1449C3.2895 18.3966 3.28784 18.6684 3.36865 18.921C3.44945 19.1737 3.60853 19.3941 3.82287 19.5503C4.03722 19.7066 4.29571 19.7906 4.56096 19.7902C4.82621 19.7899 5.08447 19.7051 5.29838 19.5483L9.75338 16.2816C9.82482 16.2293 9.91107 16.2011 9.99963 16.2011C10.0882 16.2011 10.1744 16.2293 10.2459 16.2816L14.6992 19.5474C14.913 19.7048 15.1714 19.79 15.4369 19.7907C15.7024 19.7914 15.9612 19.7076 16.1759 19.5513C16.3905 19.3951 16.5498 19.1746 16.6307 18.9217C16.7116 18.6688 16.7099 18.3968 16.6259 18.1449L14.8109 12.6991C14.7843 12.6195 14.7824 12.5336 14.8055 12.4529C14.8285 12.3721 14.8754 12.3002 14.94 12.2466L19.2684 8.65828C19.4629 8.4922 19.6018 8.27043 19.6664 8.02291C19.7309 7.77539 19.7179 7.51403 19.6292 7.27411Z" fill="#42C184" />
                        </svg>
                      </span>
                    </div>
                    <h6 class="typo-title1 title mt-1" v-if="firstTestimonial.title">{{ firstTestimonial.title }}</h6>
                    <div class="description mt-1" v-html="firstTestimonial.content"></div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="col-12 testimonials-masonry mt-2">
            <div class="testimonial-item" v-for="(item, ind) in testimonials" :key="ind">
              <div class="testimonial">
                <div class="testimonial-header d-flex flex-column align-items-center p-3 pb-2">
                  <div class="avatar mb-1">
                    <img :src="`${publicPath}${item.avatar}`" alt />
                  </div>
                  <h5 class="heading-h4-18-semi txt-primary-200 mb-1">{{ item.name }}</h5>
                  <div class="stars mb-1">
                    <span class="star mr-1" v-for="i in item.stars" :key="i">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.6292 7.27411C19.5402 7.03495 19.3803 6.82863 19.171 6.68271C18.9616 6.53679 18.7127 6.4582 18.4575 6.45744H13.385C13.2987 6.45751 13.2145 6.43076 13.1441 6.3809C13.0736 6.33104 13.0204 6.26053 12.9917 6.17911L11.1709 1.01828C11.0817 0.779745 10.9218 0.574144 10.7125 0.42899C10.5033 0.283836 10.2547 0.206055 10 0.206055C9.74538 0.206055 9.4968 0.283836 9.28756 0.42899C9.07831 0.574144 8.9184 0.779745 8.82921 1.01828L8.82504 1.03161L7.00838 6.17911C6.97977 6.2604 6.92666 6.33081 6.85637 6.38066C6.78607 6.43051 6.70205 6.45733 6.61588 6.45744H1.54171C1.28489 6.45725 1.03425 6.53617 0.823864 6.68346C0.613482 6.83075 0.453573 7.03927 0.365888 7.28066C0.278202 7.52204 0.266995 7.78458 0.333792 8.03256C0.400588 8.28054 0.542146 8.50192 0.739212 8.66661L5.05921 12.2499C5.12383 12.3036 5.17074 12.3755 5.19379 12.4562C5.21684 12.537 5.21495 12.6228 5.18838 12.7024L3.37338 18.1449C3.2895 18.3966 3.28784 18.6684 3.36865 18.921C3.44945 19.1737 3.60853 19.3941 3.82287 19.5503C4.03722 19.7066 4.29571 19.7906 4.56096 19.7902C4.82621 19.7899 5.08447 19.7051 5.29838 19.5483L9.75338 16.2816C9.82482 16.2293 9.91107 16.2011 9.99963 16.2011C10.0882 16.2011 10.1744 16.2293 10.2459 16.2816L14.6992 19.5474C14.913 19.7048 15.1714 19.79 15.4369 19.7907C15.7024 19.7914 15.9612 19.7076 16.1759 19.5513C16.3905 19.3951 16.5498 19.1746 16.6307 18.9217C16.7116 18.6688 16.7099 18.3968 16.6259 18.1449L14.8109 12.6991C14.7843 12.6195 14.7824 12.5336 14.8055 12.4529C14.8285 12.3721 14.8754 12.3002 14.94 12.2466L19.2684 8.65828C19.4629 8.4922 19.6018 8.27043 19.6664 8.02291C19.7309 7.77539 19.7179 7.51403 19.6292 7.27411Z" fill="#F09621" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="testimonial-body p-3 pt-2">
                  <h6 class="heading-h4-18-semi txt-dark-high-contrast mt-1" v-if="item.title">{{ item.title }}</h6>
                  <div class="paragraph-14-regular txt-dark-low-contrast description mt-1" v-html="item.content"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="mt-2 mt-lg-5"></div>

        <section class="faqs mt-2 mt-lg-6">
          <h2 class="section-title text-center text-primary-300">{{ $t("pricing.faq") }}</h2>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="row" v-for="(faq, i) in leftFaqItems" :key="'_faql_' + 2 * i" :class="i == 0 ? 'mt-2' : 'mt-3'">
                <div class="col-12">
                  <GpAccordion lclass="faqs-pricing" :item="faq" />
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="row" v-for="(faq, i) in rightFaqItems" :key="'_faqr_' + (2 * i + 1)" :class="i == 0 ? 'mt-2' : 'mt-3'">
                <div class="col-12">
                  <GpAccordion lclass="faqs-pricing" :item="faq" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </PerfectScrollbar>
</template>

<script>
import { mapState } from "vuex";
import { GpAccordion } from "@/core/shared/GpForms";
import Cookie from "@/utils/cookie.js";
import { serverDomain } from "@/config/index.js";
import TablePricing from "./TablePricing.vue";
import dataPlan from "../data/dataPlan.json";
import PLanPackItem from "../components/PLanPackItem.vue";
import plan from "@/modules/Pricing/mixins/plan";

const DISCOUNT_KEY = "__gfPromotion";
export default {
  name: "Pricing",
  components: {
    GpAccordion,
    TablePricing,
    PLanPackItem
  },
  mixins: [plan()],
  data() {
    return {
      prevRoute: null,

      baseurl: window.__gembase !== undefined ? window.__gembase : "/",
      activeStarter: false,
      activeProfessional: false,
      activeAdvanced: false,
      starterPrice: 15,
      professionalPrice: 29,
      advancedPrice: 59,
      rate: 1,
      discount: null,
      showTablePricing: false,
      dataPlan: dataPlan
    };
  },
  computed: {
    ...mapState("account", {
      account: state => state.shopInfo,
      plan: state => state.shopInfo.plan
    }),
    isDevStore() {
      return this.account.developmentStore;
    },
    isPaying() {
      return ["starter", "professional", "advanced"].includes(this.plan);
    },
    isShopifyStaff() {
      return this.account.shopifyPlan === "staff";
    },
    isShopifyStaffBusiness() {
      return this.account.shopifyPlan === "staff_business";
    },
    isShopifyAlumni() {
      return this.account.shopifyPlan === "shopify_alumni";
    },
    firstTestimonial() {
      return {
        name: "Ame Pure",
        title: "We used this app to create Sale & Giveaway Landing Pages.",
        avatar: require("@/core/assets/pricing/testimonials/0.jpg"),
        content: `<p>We used this app to create Sale & Giveaway Landing Pages. The functionality of the app is very straightforward and easily customized.</p><p>Whenever we had questions about "How to do smth?" a friendly support team quickly replied and even created screen videos to show us how to set up custom fields & etc.</p><p>We highly recommend using GemPages for your online store!</p>`,
        stars: 5
      };
    },
    pricingRequestLink() {
      return `https://forms.clickup.com/f/3m5v4-12685/0FZ4NQI03A25VAWMFM?domain=${this.account.shopifyDomain}&shopify_email=${this.account.email}`
    },
    testimonials() {
      return [
        {
          name: "Ame Pure",
          title: "We used this app to create Sale & Giveaway Landing Pages.",
          avatar: require("@/core/assets/pricing/testimonials/0.jpg"),
          content: `<p>We used this app to create Sale & Giveaway Landing Pages. The functionality of the app is very straightforward and easily customized.</p><p>Whenever we had questions about "How to do smth?" a friendly support team quickly replied and even created screen videos to show us how to set up custom fields & etc.</p><p>We highly recommend using GemPages for your online store!</p>`,
          stars: 5
        },
        {
          name: "Trot'Secure",
          title: "Gempages continues to improve by constantly bringing more updates",
          avatar: require("@/core/assets/pricing/testimonials/3.jpg"),
          content: `<p>Excellent application to customize all the pages of your site as you want ! Gempages continues to improve by constantly bringing more updates and content to customize. Incredible customer service : they help you to resolve all your problems with an unbeatable speed. I RECOMMEND GEMPAGES at 100%.</p>`,
          stars: 5
        },
        {
          name: "SMART+PANTS",
          title: "Making a legit brand!",
          avatar: require("@/core/assets/pricing/testimonials/2.jpg"),
          content: `<p>Amazing, the customer support is amazing and I have been using it for a long time :). I would recommend it to everyone who is interested in making a legit brand!</p>`,
          stars: 5
        },
        {
          name: "Mid Modern Living",
          title: "Coming from square space",
          avatar: require("@/core/assets/pricing/testimonials/1.jpg"),
          content: `<p>Coming from square space I wanted to find a platform that was similar to building webpages. I tried other apps close to gem pages but nothing compared. Its easy to use and the customer support is the best. Any issues I had they helped out with especially performing specialty coding on my product pages.</p>`,
          stars: 5
        },

        {
          name: "Blue Confort",
          title: "J'utilise Gempages depuis des mois.",
          avatar: require("@/core/assets/pricing/testimonials/4.jpg"),
          content: `<p>J'utilise Gempages depuis des mois. Le rendu de la page est toujours un plaisir à monter grâce à cette application. Un gros travail a été fait sur la rapidité de chargement des pages et ça se sent.</p><p>L'équipe du support client est toujours très réactive, professionnelle et aimable.</p>`,
          stars: 5
        },
        {
          name: "Premiere Tactical",
          title: "I am building a large (60K) product store",
          avatar: require("@/core/assets/pricing/testimonials/5.jpg"),
          content: `<p>I am building a large (60K) product store and have searched for page builders to help me do this. Unfortunately, I've had bad luck with this. Then I found GemPages and have had wonderful success. The app may seem a bit daunting at first, but don't let that stop you. With a tiny bit of patience you will master this app and it will perform really well for you. I have also reached out to the support team and Chris himself has helped me, including making me a how to video on my specific request I had for some customization. I highly encourage you to try this app... Its the best I've used so far and Im very happy to have found it and to have met Chris online through the support.</p>`,
          stars: 5
        },
        {
          name: "Hemsley Organics",
          title: "IF YOU ARE LOOKING FOR A STORE BUILDER LOOK NO FURTHER!",
          avatar: require("@/core/assets/pricing/testimonials/7.jpg"),
          content: `<p>Really good app - it is far better than shopifys web builder. It gives you far more ability to fully customise your store. Very easy to use and the customer service is one of the best experiences i have had. Any minor issues i have had ( our own fault ) they have sorted straight away and even sent videos on how to sort in the future. Thanks Guys ***** <a href="www.hemsleyorganics.com" class="link" target="_blank">www.hemsleyorganics.com</a></p>`,
          stars: 5
        },
        {
          name: "PassionGive",
          title: "I hired many freelance developers",
          avatar: require("@/core/assets/pricing/testimonials/6.jpg"),
          content: `<p>I hired many freelance developers prior to finding this solution and for about a year I thought we were making good progress. I was easily able to recreate the entire store using GemPages in about one hour. Anyone still hiring a "developer" should seriously consider looking into this app now!</p><p>Owning a shopify store is not the same without this revolutionary page creator tool. Now having 100% control over every aspect of theme customization capabilities imaginable opens the door to exciting new possibilities for any startup business!</p><p>The future of eCommerce is bright with GemPages at the foundation. Amazing team effort has all of us wondering what else is possible with this incredible app? That is why I am excited for future development.</p>`,
          stars: 5
        }
      ];
    },
    faqs() {
      if (this.isDevStore) {
        return [
          {
            items: [
              { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
              { title: this.$t("pricing.faqs.q7"), content: this.$t("pricing.faqs.a7") },
              { title: this.$t("pricing.faqs.q18"), content: this.$t("pricing.faqs.a18") },
              { title: this.$t("pricing.faqs.q19"), content: this.$t("pricing.faqs.a19") },
              { title: this.$t("pricing.faqs.q20"), content: this.$t("pricing.faqs.a20") },
              { title: this.$t("pricing.faqs.q21"), content: this.$t("pricing.faqs.a21") },
              { title: this.$t("pricing.faqs.q22"), content: this.$t("pricing.faqs.a22.business") },
              { title: this.$t("pricing.faqs.q23"), content: this.$t("pricing.faqs.a23") },
              { title: this.$t("pricing.faqs.q24"), content: this.$t("pricing.faqs.a24") },
              { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") }
            ]
          }
        ];
      }

      if (this.isShopifyStaffBusiness || this.isShopifyAlumni) {
        if (this.isPaying) {
          return [
            {
              items: [
                { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
                { title: this.$t("pricing.faqs.q7"), content: this.$t("pricing.faqs.a7") },
                { title: this.$t("pricing.faqs.q17"), content: this.$t("pricing.faqs.a17") },
                { title: this.$t("pricing.faqs.q30"), content: this.$t("pricing.faqs.a30") },
                { title: this.$t("pricing.faqs.q31"), content: this.$t("pricing.faqs.a31") },
                { title: this.$t("pricing.faqs.q32"), content: this.$t("pricing.faqs.a32") },
                { title: this.$t("pricing.faqs.q33"), content: this.$t("pricing.faqs.a33") },
                { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") },
                { title: this.$t("pricing.faqs.q35"), content: this.$t("pricing.faqs.a35") }
              ]
            }
          ];
        }

        return [
          {
            items: [
              { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
              { title: this.$t("pricing.faqs.q7"), content: this.$t("pricing.faqs.a7") },
              { title: this.$t("pricing.faqs.q11"), content: this.$t("pricing.faqs.a11.business") },
              { title: this.$t("pricing.faqs.q12"), content: this.$t("pricing.faqs.a12.business") },
              { title: this.$t("pricing.faqs.q13"), content: this.$t("pricing.faqs.a13") },
              { title: this.$t("pricing.faqs.q14"), content: this.$t("pricing.faqs.a14") },
              { title: this.$t("pricing.faqs.q17"), content: this.$t("pricing.faqs.a17") },
              { title: this.$t("pricing.faqs.q27"), content: this.$t("pricing.faqs.a27") },
              { title: this.$t("pricing.faqs.q30"), content: this.$t("pricing.faqs.a30") },
              { title: this.$t("pricing.faqs.q31"), content: this.$t("pricing.faqs.a31") },
              { title: this.$t("pricing.faqs.q33"), content: this.$t("pricing.faqs.a33") },
              { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") },
              { title: this.$t("pricing.faqs.q35"), content: this.$t("pricing.faqs.a35") }
            ]
          }
        ];
      }

      if (this.isShopifyStaff) {
        return [
          {
            items: [
              { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
              { title: this.$t("pricing.faqs.q6"), content: this.$t("pricing.faqs.a6") },
              { title: this.$t("pricing.faqs.q9"), content: this.$t("pricing.faqs.a9") },
              { title: this.$t("pricing.faqs.q15"), content: this.$t("pricing.faqs.a15") },
              { title: this.$t("pricing.faqs.q16"), content: this.$t("pricing.faqs.a16") },
              { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") }
            ]
          }
        ];
      }

      if (this.isPaying) {
        return [
          {
            items: [
              { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
              { title: this.$t("pricing.faqs.q5"), content: this.$t("pricing.faqs.a5") },
              { title: this.$t("pricing.faqs.q7"), content: this.$t("pricing.faqs.a7") },
              { title: this.$t("pricing.faqs.q29"), content: this.$t("pricing.faqs.a29") },
              { title: this.$t("pricing.faqs.q30"), content: this.$t("pricing.faqs.a30") },
              { title: this.$t("pricing.faqs.q31"), content: this.$t("pricing.faqs.a31") },
              { title: this.$t("pricing.faqs.q32"), content: this.$t("pricing.faqs.a32") },
              { title: this.$t("pricing.faqs.q33"), content: this.$t("pricing.faqs.a33") },
              { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") },
              { title: this.$t("pricing.faqs.q35"), content: this.$t("pricing.faqs.a35") }
            ]
          }
        ];
      }

      if (this.isFreeTrial) {
        return [
          {
            items: [
              { title: this.$t("pricing.faqs.q2"), content: this.$t("pricing.faqs.a2") },
              { title: this.$t("pricing.faqs.q7"), content: this.$t("pricing.faqs.a7") },
              { title: this.$t("pricing.faqs.q11"), content: this.$t("pricing.faqs.a11.business") },
              { title: this.$t("pricing.faqs.q12"), content: this.$t("pricing.faqs.a12.business") },
              { title: this.$t("pricing.faqs.q13"), content: this.$t("pricing.faqs.a13") },
              { title: this.$t("pricing.faqs.q14"), content: this.$t("pricing.faqs.a14") },
              { title: this.$t("pricing.faqs.q27"), content: this.$t("pricing.faqs.a27") },
              { title: this.$t("pricing.faqs.q29"), content: this.$t("pricing.faqs.a29") },
              { title: this.$t("pricing.faqs.q30"), content: this.$t("pricing.faqs.a30") },
              { title: this.$t("pricing.faqs.q31"), content: this.$t("pricing.faqs.a31") },
              { title: this.$t("pricing.faqs.q33"), content: this.$t("pricing.faqs.a33") },
              { title: this.$t("pricing.faqs.q34"), content: this.$t("pricing.faqs.a34") },
              { title: this.$t("pricing.faqs.q35"), content: this.$t("pricing.faqs.a35") }
            ]
          }
        ];
      }
      return [];
    },
    faqItems() {
      if (!this.faqs) return [];
      let items = [];
      this.faqs.forEach(item => items.push(...item.items));
      return items;
    },
    leftFaqItems() {
      return this.faqItems.filter((item, ind) => ind % 2 == 0);
    },
    rightFaqItems() {
      return this.faqItems.filter((item, ind) => ind % 2 == 1);
    },
    starterPack() {
      return [
        { content: "pricing.unlimitedPage", disabled: false, highlight: false },
        {
          content: "pricing.2pageTypes",
          disabled: false,
          highlight: false ,
          label: {
            type: "tooltip",
            text: this.$t("pricing.2pageTypesTooltip"),
            minWidth: 113,
          }
        },
        { content: "pricing.dragDrop", disabled: false, highlight: false },
        {
          content: "pricing.pageSettings",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.activityLog",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.30Integrations",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.65Elements",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.40BasicTemplates",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.globalStyle",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.globalStyle.1Preset",
            type: "warning"
          }
        },
        {
          content: "pricing.seoOptimization",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.highspeedCdnLoading",
          disabled: false,
          highlight: false
        },
        { content: "pricing.emailSupport", disabled: false, highlight: false }
      ];
    },
    professionalPack() {
      return [
        {
          content: "pricing.allPageTypes",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.advancedPageSettings",
          disabled: false,
          highlight: false
        },
        { content: "pricing.10ProTemplates", disabled: false, highlight: false },
        {
          content: "pricing.globalStyle",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.globalStyle.3Presets",
            type: "warning"
          }
        },
        { content: "pricing.stickAddToCart", disabled: false, highlight: false },
        {
          content: "pricing.customCodeEditor",
          disabled: false,
          highlight: false
        },
        {
          content: "pricing.myLibrary",
          disabled: false,
          highlight: false,
          label: {
            type: "tooltip",
            text: this.$t("pricing.myLibraryTooltip"),
          }
        },
        {
          content: "pricing.abtesting",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.2campaigns",
            type: "warning"
          }
        },
        // {
        //   content: "pricing.supportChat",
        //   disabled: false,
        //   highlight: false
        // }
        {
          content: "pricing.liveChat",
          disabled: false,
          highlight: false
        }
      ];
    },
    advancedPack() {
      const list = [
        {
          content: "pricing.globalStyle",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.globalStyle.20Presets",
            type: "warning"
          }
        },
        {
          content: "pricing.abtesting",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.20campaigns",
            type: "warning"
          }
        },
        {
          content: "pricing.pageScheduling",
          disabled: false,
          highlight: false
        },
        // {
        //   content: "pricing.support",
        //   disabled: false,
        //   highlight: false,
        //   label: {
        //     text: "pricing.instant",
        //     type: "secondary"
        //   }
        // }
        {
          content: "pricing.instantLandingPages",
          disabled: false,
          highlight: true
        },
        {
          content: "pricing.prioritySupport",
          disabled: false,
          highlight: false,
          label: {
            text: "pricing.instant",
            type: "secondary"
          }
        }
      ];

      if (this.account?.isOldAdvancedPlan) {
        list.unshift({
          content: "pricing.03domainInstallation",
          disabled: false,
          highlight: false,
          label: {
            text: this.$t("pricing.03domainInstallationLabel"),
            type: "warning2",
            articleLink: "https://help.gempages.net/articles/new-pricing-2021"
          }
        });
      }

      return list;
    },
    planNo() {
      if (this.plan == "starter") {
        return 1;
      } else if (this.plan == "professional") {
        return 2;
      } else if (this.plan == "advanced") {
        return 3;
      }
      return 0;
    },
    applyDiscountFor() {
      return {
        starter: this.shouldApplyDiscount(1),
        professional: this.shouldApplyDiscount(2),
        advanced: this.shouldApplyDiscount(3)
      };
    },
    hasAnyDiscount() {
      return this.applyDiscountFor.starter || this.applyDiscountFor.professional || this.applyDiscountFor.advanced;
    },
    announcement() {
      if (this.account.shopifyPlan === "staff") {
        return this.$t("pricing.announcement.shopifyStaff");
      }
      if (this.account.shopifyPlan === "staff_business") {
        return this.$t("pricing.announcement.shopifyStaffBusiness");
      }
      if (this.account.shopifyPlan === "shopify_alumni") {
        return this.$t("pricing.announcement.shopifyAlumni");
      }

      return false;
    },
    isShowAdvandDiscount() {
      const checkShopifyPlan = ["staff_business", "shopify_alumni"].includes(this.account.shopifyPlan);
      return this.account.advancedCampaignRate && this.account.advancedCampaignRate != 1 && !this.account.hasAgency && !checkShopifyPlan;
    },
    isShowBusinessDiscount() {
      const checkShopifyPlan = ["staff_business", "shopify_alumni"].includes(this.account.shopifyPlan);
      return this.account.businessDiscountRate && this.account.businessDiscountRate != 1 && !this.account.hasAgency && !checkShopifyPlan;
    }
  },
  watch: {},
  created() {
    if (this.account.hasAgency) {
      this.rate = 0.9;
    }
    if (["staff_business", "shopify_alumni"].includes(this.account.shopifyPlan)) {
      this.rate = 0.5;
    }
    this.checkDiscount();
  },
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://fast.wistia.com/embed/medias/ofwzjjtqyc.jsonp");
    document.head.appendChild(recaptchaScript);
    let recaptchaScript_1 = document.createElement("script");
    recaptchaScript_1.setAttribute("src", "https://fast.wistia.com/assets/external/E-v1.js");
    document.head.appendChild(recaptchaScript_1);
  },
  methods: {
    getPlanNo(planText) {
      if (planText == "starter") {
        return 1;
      } else if (planText == "professional") {
        return 2;
      } else if (planText == "advanced") {
        return 3;
      }
      return 0;
    },
    exitUpgrade() {
      if (this.prevRoute.name != null) this.$router.go(-1);
      else this.$router.push({ name: "Dashboard" });
    },
    shouldApplyDiscount(plan) {
      if (this.discount?.shopify_domain && this.discount?.shopify_domain != this.account.shopifyDomain) {
        return false;
      }
      if (["shopify_alumni", "staff_business"].includes(this.account.shopifyPlan)) {
        return true;
      }
      if (this.discount?.plan == "all") {
        return (this.hasAgency || this.discount) && this.planNo < plan;
      } else {
        return ((plan == 1 && this.discount?.plan == "starter") || (plan == 2 && this.discount?.plan == "professional") || (plan == 3 && this.discount?.plan == "advanced")) && this.planNo < plan;
      }
    },

    paymentLink(plan) {
      let url = serverDomain() + "/admin/payment/charge?plan=" + plan + "&shop=" + this.account.shopifyDomain;

      if ((plan == "advanced" && this.isShowAdvandDiscount) || (plan == "professional" && this.isShowBusinessDiscount)) {
        return url
      }

      if (this.planNo > this.getPlanNo(plan)) {
        return url;
      }

      if (this.discount) {
        if (this.discount.shopify_domain && this.discount.shopify_domain != this.account.shopifyDomain) {
          return url;
        }
        if (this.discount.plan == "all" || this.discount.plan == plan) {
          url += "&code=" + this.discount.code;
        }
      }

      return url;
    },
    clearCookie() {
      Cookie.remove(DISCOUNT_KEY);
      // eslint-disable-next-line no-console
      console.info("Discount code cookie deleted");
    },
    checkDiscount() {
      let cData = Cookie.get(DISCOUNT_KEY);
      if (!cData || cData == undefined || cData == null) {
        return;
      }
      cData = decodeURIComponent(cData);
      let rawData = cData.replace(/\n/g, "");
      // base64 decode: atob()
      try {
        let json = atob(rawData);
        const discountObject = JSON.parse(json);
        let d = new Date();
        const startTime = discountObject.start_time;
        const endTime = discountObject.end_time;
        if (d < startTime) {
          throw new Error("Discount not started yet.");
        }
        if (d > endTime) {
          throw new Error("Discount has ended.");
        }
        this.discount = discountObject;
      } catch (error) {
        this.discount = null;
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    applyDiscount(basePrice) {
      const agencyPrice = basePrice * this.rate;
      let discountPrice = this.getDiscountPrice(basePrice);
      return discountPrice < agencyPrice;
    },
    getDiscountPrice(basePrice) {
      if (this.discount) {
        if (this.discount.unit == "%") {
          return (basePrice * (100 - this.discount.discount)) / 100; // ?? :D ?? cai nay tai backend nhe 😒
        }
        if (this.discount.unit == "$") {
          return basePrice - this.discount.discount; // ?? :D ?? cai nay tai backend nhe 😒
        }
      }
      return basePrice;
    },
    toggleTablePricing() {
      this.showTablePricing = !this.showTablePricing;
    },
    getPriceForPlan(plan) {
      if (plan == "starter") {
        if (!(this.applyDiscount(this.starterPrice) && this.applyDiscountFor.starter)) {
          return this.starterPrice * this.rate;
        } else {
          return this.getDiscountPrice(this.starterPrice);
        }
      } else if (plan == "professional") {
        if (this.isShowBusinessDiscount) {
          return (this.professionalPrice * (this.account.businessDiscountRate * 100)) / 100;
        } else if (!(this.applyDiscount(this.professionalPrice) && this.applyDiscountFor.professional)) {
          return this.professionalPrice * this.rate;
        } else {
          return this.getDiscountPrice(this.professionalPrice);
        }
      } else if (plan == "advanced") {
        if (this.isShowAdvandDiscount) {
          return this.advancedPrice * this.account.advancedCampaignRate;
        }
        if (!(this.applyDiscount(this.advancedPrice) && this.applyDiscountFor.advanced)) {
          return this.advancedPrice * this.rate;
        } else {
          return this.getDiscountPrice(this.advancedPrice);
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
};
</script>

<style lang="scss" scoped>
$bg-gray: linear-gradient(204.4deg, $neutral5 3.26%, #d9e7ff 98.18%);
$bg-grey: linear-gradient(204.35deg, $neutral5 3.26%, #d9e7ff 98.18%);
$bg-yellow: linear-gradient(180deg, #fdca13 0%, #ffb603 100%);
$professional-color: map-get($primary, "300");
$screen-md: 1200px;

.request {
  border: 1px solid map-get($light-grey, "300");

  &__make {
    width: 100%;

    @media screen and (min-width: $screen-md) {
      width: auto;
    }
  }

  &__left {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("~@/core/assets/new-pricing/background-request-1.svg");
  }

  &__right {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("~@/core/assets/new-pricing/background-request-2.svg");
  }

  &__text {
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;

    @media screen and (min-width: $screen-md) {
      font-size: 20px;
      line-height: 30px;
    }
  }
}

.promotion-applied {
  background: $cPrimary;
  border-radius: $radius;
  padding: 12px 24px;
}

.btn-border-grey {
  background: #ffffff;
  border: 1px solid map-get($light-grey, "200");
  color: map-get($dark-text-new, "high-contrast");

  &:not(.disabled):not(:disabled):hover {
    border-color: map-get($dark-text-new, "high-contrast");
  }

  &:not(.disabled):not(:disabled):active {
    border-color: map-get($light-grey, "200");
  }
}

.btn-solid-blue {
  background: $professional-color;
  color: #ffffff;
  border-radius: $radius;

  &:not(.disabled):not(:disabled):hover {
    background: $mono4;
  }

  &:not(.disabled):not(:disabled):active {
    background: $professional-color;
  }

  &.disabled,
  &:disabled {
    background-color: map-get($light-grey, "300");
    border: 1px solid transparent;
  }
}

.btn-solid-blue,
.btn-border-grey {
  user-select: none;

  &.disabled,
  &:disabled {
    background-color: map-get($light-grey, "300");
    border: 1px solid transparent;
    color: map-get($dark-text-new, "disabled");;
  }
}

.pricing {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // overflow-y: overlay;
  background-color: map-get($hybrid-shade-light, "disabled");;
  // background-image: url(~@/core/assets/pricing/bg.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-attachment: local;
  display: flex;
  padding: 80px 80px 0 80px;

  z-index: 9999999999999;

  .exit-btn {
    @include flex-center;
    position: absolute;
    color: map-get($dark-text-new, "low-contrast");
    top: 42px;
    right: 42px;
    padding: 12px;
    cursor: pointer;
    > i {
      font-size: 14px;
    }
    &:hover {
      background: $textDarkModeHigh;
    }
  }

  .actual-fullwidth {
    margin: 0 -80px;
    width: calc(100% + 160px);
    padding-bottom: 64px;
    background-image: url("~@/core/assets/pricing/pricing-bg.png");
    background-size: 100% auto;
    background-repeat: repeat-y;
  }

  > .header {
    display: flex;

    .title {
      font-weight: bold;
      font-size: 40px;
      line-height: 140%;
    }
  }

  &-sub {
    color: #fff;
    padding: 2px 8px;
    position: relative;
    margin-right: 4px;
    border-radius: $radius;

    &-live {
      background: #ec4b4b;
    }

    &-instant {
      background: #f09621;
    }
  }

  .btn {
    min-height: 48px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }

  .plans {
    .restricted-multi-stores {
      padding: 16px 40px;
      border: 1px solid #d3d7e5;
      border-radius: 3px;
    }
  }

  &__title {
    font-size: 40px;
    line-height: 60px;
    /* identical to box height, or 150% */
    font-weight: 700;
    letter-spacing: 0.01em;
  }
}

.plan {
  // padding-top: 20px;
  border-radius: 10px;
  align-self: flex-start;

  &-header {
    padding: 24px 32px 0 24px;
    min-height: 222px;

    display: flex;
    position: relative;
    border: solid 1px map-get($light-grey, "300");
    border-bottom: none;
    border-radius: $radius $radius 0px 0px;
    $url: url("data:image/svg+xml,%3Csvg width='69' height='50' viewBox='0 0 69 50' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='69' height='50'%3E%3Crect width='69' height='50' fill='%23C4C4C4'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cg opacity='0.1'%3E%3Cpath d='M10.1724 6.65686L7.34394 3.82843L10.1724 1.00001L13.0008 3.82843L10.1724 6.65686Z' fill='%23212121'/%3E%3Cpath d='M10.1724 25L7.34394 22.1716L10.1724 19.3431L13.0008 22.1716L10.1724 25Z' fill='%23212121'/%3E%3Cpath d='M10.1724 43.3432L7.34394 40.5147L10.1724 37.6863L13.0008 40.5147L10.1724 43.3432Z' fill='%23212121'/%3E%3Cpath d='M28.3442 6.65686L25.5158 3.82843L28.3442 1.00001L31.1727 3.82843L28.3442 6.65686Z' fill='%23212121'/%3E%3Cpath d='M28.3442 25L25.5158 22.1716L28.3442 19.3431L31.1727 22.1716L28.3442 25Z' fill='%23212121'/%3E%3Cpath d='M28.3442 43.3432L25.5158 40.5147L28.3442 37.6863L31.1727 40.5147L28.3442 43.3432Z' fill='%23212121'/%3E%3Cpath d='M46.5161 6.65686L43.6877 3.82843L46.5161 1.00001L49.3445 3.82843L46.5161 6.65686Z' fill='%23212121'/%3E%3Cpath d='M46.5161 25L43.6877 22.1716L46.5161 19.3431L49.3445 22.1716L46.5161 25Z' fill='%23212121'/%3E%3Cpath d='M46.5161 43.3432L43.6877 40.5147L46.5161 37.6863L49.3445 40.5147L46.5161 43.3432Z' fill='%23212121'/%3E%3Cpath d='M64.688 6.65686L61.8596 3.82843L64.688 1.00001L67.5164 3.82843L64.688 6.65686Z' fill='%23212121'/%3E%3Cpath d='M64.688 25L61.8596 22.1716L64.688 19.3431L67.5164 22.1716L64.688 25Z' fill='%23212121'/%3E%3Cpath d='M64.688 43.3432L61.8596 40.5147L64.688 37.6863L67.5164 40.5147L64.688 43.3432Z' fill='%23212121'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

    &:before {
      background: $url;
      background-size: 100% 100%;
      content: "";
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 69px;
      height: 50px;
      background-repeat: no-repeat !important;
    }

    .gem {
      margin-right: 16px;
      width: 100px;
      display: flex;
      justify-content: center;
      img {
        max-width: 100%;
        align-self: flex-start;
      }
    }

    .describe {
      flex: 1;
    }

    .info {
      /* margin-bottom: 4px; */

      .balancer {
        /* min-height: 50px; */
      }
    }

    .plan-price {
      display: flex;
      font-weight: 600;
      font-size: 48px;
      line-height: 48px;
      letter-spacing: 0.01em;

      .billing-period {
        align-self: flex-end;
        /* font-weight: normal;
        font-size: 24px;
        line-height: 150%; */
        margin-bottom: 4px;
      }
      .old-price {
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 1.5em;
        text-decoration: line-through;
        color: map-get($dark-text-new, "disabled");
        &-professional {
          color: map-get($light-text, "low-contrast");
        }
      }
    }
  }

  .feature-container {
    padding-left: 32px;
    padding-right: 32px;
  }

  &.professional {
    z-index: 2;
    position: relative;

    .features {
      border-color: $professional-color;
      border-width: 2px;
      border-top: none;
      min-height: 740px;
      padding: 0 0 22px;
    }

    .feature-container {
      // padding-bottom: 48px !important;
    }

    .highlight {
      color: $textLightModeHigh;
    }

    .plan-header {
      // padding: 32px 28px 24px 24px;
      $url: url("data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.2'%3E%3Cpath d='M2.82861 18.3431L0.000185966 15.5147L2.82861 12.6863L5.65704 15.5147L2.82861 18.3431Z' fill='%237190FF'/%3E%3Cpath d='M2.82861 36.6863L0.000185966 33.8579L2.82861 31.0295L5.65704 33.8579L2.82861 36.6863Z' fill='%237190FF'/%3E%3Cpath d='M2.82861 55.0295L0.000185966 52.2011L2.82861 49.3726L5.65704 52.2011L2.82861 55.0295Z' fill='%237190FF'/%3E%3Cpath d='M21.0005 18.3431L18.1721 15.5147L21.0005 12.6863L23.8289 15.5147L21.0005 18.3431Z' fill='%237190FF'/%3E%3Cpath d='M21.0005 36.6863L18.1721 33.8579L21.0005 31.0295L23.8289 33.8579L21.0005 36.6863Z' fill='%237190FF'/%3E%3Cpath d='M21.0005 55.0295L18.1721 52.2011L21.0005 49.3726L23.8289 52.2011L21.0005 55.0295Z' fill='%237190FF'/%3E%3Cpath d='M39.1724 18.3431L36.3439 15.5147L39.1724 12.6863L42.0008 15.5147L39.1724 18.3431Z' fill='%237190FF'/%3E%3Cpath d='M39.1724 36.6863L36.3439 33.8579L39.1724 31.0295L42.0008 33.8579L39.1724 36.6863Z' fill='%237190FF'/%3E%3Cpath d='M39.1724 55.0295L36.3439 52.2011L39.1724 49.3726L42.0008 52.2011L39.1724 55.0295Z' fill='%237190FF'/%3E%3Cpath d='M57.3442 18.3431L54.5158 15.5147L57.3442 12.6863L60.1727 15.5147L57.3442 18.3431Z' fill='%237190FF'/%3E%3Cpath d='M57.3442 36.6863L54.5158 33.8579L57.3442 31.0295L60.1727 33.8579L57.3442 36.6863Z' fill='%237190FF'/%3E%3Cpath d='M57.3442 55.0295L54.5158 52.2011L57.3442 49.3726L60.1727 52.2011L57.3442 55.0295Z' fill='%237190FF'/%3E%3C/g%3E%3C/svg%3E%0A");
      background: $url top right no-repeat, $professional-color;
      border-color: $professional-color;
      min-height: 246px;

      &:before {
        $url: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.41414 12.9941C9.2257 12.9941 9.05818 12.9104 8.9535 12.7848L5.79184 9.35091C5.56152 9.09967 5.58248 8.70183 5.83372 8.4715C6.08496 8.24118 6.48281 8.26214 6.71313 8.51338L9.43506 11.4656L16.9728 3.94888C17.224 3.69764 17.6219 3.69764 17.8522 3.94888C18.0825 4.20012 18.1034 4.59796 17.8522 4.82829L9.85386 12.8057C9.74914 12.9313 9.58166 12.9941 9.41414 12.9941Z' fill='%23456BF2'/%3E%3Cpath d='M10.0003 18.3333C5.41489 18.3333 1.66699 14.5854 1.66699 9.99998C1.66699 5.41456 5.41489 1.66663 10.0003 1.66663C10.3563 1.66663 10.6285 1.93883 10.6285 2.29475C10.6285 2.65067 10.3563 2.92287 10.0003 2.92287C6.10585 2.92287 2.92328 6.10544 2.92328 9.99994C2.92328 13.8944 6.10585 17.077 10.0003 17.077C13.8948 17.077 17.0774 13.8944 17.0774 9.99994C17.0774 9.64398 17.3496 9.37182 17.7055 9.37182C18.0615 9.37182 18.3337 9.64402 18.3337 9.99994C18.3337 14.5854 14.5858 18.3333 10.0003 18.3333Z' fill='%23456BF2'/%3E%3C/svg%3E%0A");
        background: $url;
        // width: 85px;
        // height: 70px;
      }

      .info {
        .balancer {
          // min-height: 54px;
        }
      }

      .dollar {
        // font-weight: 600;
        // font-size: 32px;
        // line-height: 125%;
      }

      .amount {
        // font-weight: 600;
        // font-size: 64px;
        // line-height: 120%;
      }

      .billing-period {
        /* font-weight: normal;
        font-size: 24px;
        line-height: 125%; */
        margin-bottom: 8px;
      }
    }
    .btn:not(.disabled):not(:disabled) {
      background: map-get($primary, "300");
      border: none;
      color: map-get($light-grey, "600");
      &:hover {
        background: map-get($primary, "200");
      }
    }
  }

  &.starter &-header,
  &.advanced &-header {
    background: map-get($light-grey, "500");
  }

  .features {
    border: solid 1px map-get($light-grey, "300");
    border-top: none;
    min-height: 700px;
    display: flex;
    justify-content: center;
    border-radius: 0 0 $radius $radius;
  }

  .feature-container {
    display: flex;
    flex-direction: column;
    border-radius: 0 0 10px 10px;
    background: $neutral5;
    position: relative;
    width: 100%;

    > .bottom-one {
      align-self: center;
      position: absolute;
      bottom: -20px;
    }

    a:last-child {
      margin-top: auto;
    }
  }
}

.list {
  list-style-type: none;
  // margin-right: -44px;

  li {
    padding-left: 38px;
    position: relative;

    &:not(:first-child) {
      margin-top: 16px;
    }

    &:before {
      content: "";
      position: absolute;
      $size: 22px;
      width: $size;
      height: $size;
      top: 0;
      left: 0;
      background-image: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.2585 13.7183L7.77156 9.9363C7.77151 9.93625 7.77146 9.93619 7.7714 9.93613C7.41248 9.54479 6.79266 9.51077 6.39882 9.87182C6.00732 10.2307 5.97323 10.8507 6.33433 11.2446L6.33455 11.2448L10.5055 15.7749C10.6725 15.9734 10.9348 16.1022 11.2263 16.1022C11.4791 16.1022 11.7443 16.0087 11.9173 15.8051L22.4683 5.28167C22.8705 4.91033 22.8226 4.29027 22.4751 3.91116C22.1092 3.51201 21.4852 3.51892 21.0977 3.90642C21.0977 3.90643 21.0977 3.90644 21.0977 3.90646L11.2585 13.7183Z' fill='%233C67FF' stroke='%233C67FF' stroke-width='0.3'/%3E%3Cpath d='M0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C18.1356 23.15 23.15 18.1356 23.15 12C23.15 11.4473 22.7235 11.0209 22.1709 11.0209C21.6182 11.0209 21.1918 11.4473 21.1918 12C21.1918 17.0579 17.0579 21.1917 12 21.1917C6.94213 21.1917 2.8083 17.0579 2.8083 12C2.8083 6.94208 6.94213 2.80824 12 2.80824C12.5527 2.80824 12.9791 2.38178 12.9791 1.82912C12.9791 1.27647 12.5527 0.85 12 0.85C5.86438 0.85 0.85 5.86443 0.85 12Z' fill='%233C67FF' stroke='%233C67FF' stroke-width='0.3'/%3E%3C/svg%3E%0A");
      background-position-x: 0;
      background-position-y: 0;
      // box-shadow: 0px 7px 15px rgba(0, 24, 46, 0.1);
    }

    &.disabled {
      &:before {
        background-image: url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C18.1356 23.15 23.15 18.1356 23.15 12C23.15 11.4473 22.7235 11.0209 22.1709 11.0209C21.6182 11.0209 21.1918 11.4473 21.1918 12C21.1918 17.0579 17.0579 21.1917 12 21.1917C6.94213 21.1917 2.8083 17.0579 2.8083 12C2.8083 6.94208 6.94213 2.80824 12 2.80824C12.5527 2.80824 12.9791 2.38178 12.9791 1.82912C12.9791 1.27647 12.5527 0.85 12 0.85C5.86438 0.85 0.85 5.86443 0.85 12Z' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.3'/%3E%3Cpath d='M12 0.85C5.86438 0.849999 0.85 5.86438 0.85 12C0.85 18.1356 5.86438 23.15 12 23.15C12.5527 23.15 12.9791 22.7235 12.9791 22.1709C12.9791 21.6182 12.5527 21.1918 12 21.1918C6.94213 21.1918 2.80829 17.0579 2.80829 12C2.80829 6.94213 6.94213 2.8083 12 2.8083C17.0579 2.8083 21.1918 6.94213 21.1918 12C21.1918 12.5527 21.6182 12.9791 22.1709 12.9791C22.7235 12.9791 23.15 12.5527 23.15 12C23.15 5.86438 18.1356 0.85 12 0.85Z' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.3'/%3E%3Crect x='6' y='11' width='12' height='2' rx='1' fill='%239E9E9E' stroke='%239E9E9E' stroke-width='0.5'/%3E%3C/svg%3E%0A");
      }
      .main-text {
        text-decoration: line-through;
      }
    }
    .label {
      padding: 2px 8px;
      color: $light1;
      margin-left: 4px;
      border-radius: $radius;
      text-transform: uppercase;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      &.danger {
        background: #e8486c;
      }
      &.secondary {
        background: map-get($accent-green-new, "400");
        color: map-get($dark-text-new, "low-contrast");
      }
      &.warning {
        background: map-get($accent-amber, "400");
        color: map-get($dark-text-new, "low-contrast");
      }
    }
  }
}

.gempage-link {
  /deep/ {
    a.link {
      text-decoration: none;
      color: map-get($primary, "300");
    }
  }
}

.plans {
  .star {
    margin-left: 6px;
    margin-right: 6px;

    svg {
      width: 20px;
      height: 20px;
    }

    &.medium {
      svg {
        width: 23.34px;
        height: 23.34px;
      }
    }

    &.big {
      svg {
        width: 26.67px;
        height: 26.67px;
      }
    }
  }
}

.testimonials-masonry {
  column-count: 3;
  column-gap: 24px;
}

.testimonial-item {
  display: inline-block;
  margin: 0 0 24px;
  width: 100%;
}

.testimonial {
  display: flex;
  flex-direction: column;
  background: $neutral5;
  border-radius: $radius;
  @include trans-all;

  &:hover {
    @include trans-all;

    box-shadow: 0 12px 19px -7px rgba(4, 91, 171, 0.3);
  }

  &-header {
    border-bottom: 1px solid $light3;
  }

  .avatar {
    img {
      border-radius: 50%;
      $ava-size: 46px;
      width: $ava-size;
      height: $ava-size;
    }
  }

  .description {
    font-weight: 300;
    font-size: 14px;
    line-height: 180%;
  }
}

.section-title {
  @include flex-center;
  font-size: 40px;
  line-height: 150%;
  font-weight: 700;
}

.shopify {
  display: inline-flex;
  flex-direction: column;

  .label,
  .stars {
    @include flex-center;
    line-height: 0;
  }

  .star {
    // &:not(:first-child) {
    margin-left: 5px;
    // }
  }

  // .label svg {}
}

.faqs {
  ::v-deep {
    .accordion-item {
      border-radius: 5px;
      padding: 16px 24px;
      padding-bottom: 4px;

      .heading {
        @include trans-all;

        .title {
          @include trans-all;
        }
      }

      .heading-bounder {
        margin: -16px -24px 0 -24px;
        padding: 16px 24px 0 24px;

        &:hover {
          background: $light3;
          .heading,
          .heading .title {
            color: $textLightModeHigh !important;
          }
        }
      }

      &:hover {
        &:not(.active) {
          background: $light3;
        }
      }

      &.active .heading-bounder {
        border-bottom: 1px solid $light3;
        margin-bottom: 16px;
      }
    }
  }
}

.video-review {
  // margin-bottom: 60px;
  // box-shadow: 0px 8px 19px rgba(4, 91, 171, 0.1);

  .video-wrapper {
    border-radius: 5px 0px 0px 5px;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .testimonial {
    box-shadow: none;
    border-radius: inherit;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    pointer-events: none;
  }
}

.fixed-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  // z-index: 10;
}

.agency-plan {
  background: #fff;
  box-shadow: 0px 0.11069px 0.85785px rgba(0, 0, 0, 0.0112458), 0px 0.266004px 2.06153px rgba(0, 0, 0, 0.0161557), 0px 0.500862px 3.88168px rgba(0, 0, 0, 0.02), 0px 0.893452px 6.92426px rgba(0, 0, 0, 0.0238443), 0px 1.6711px 12.9511px rgba(0, 0, 0, 0.0287542), 0px 4px 31px rgba(0, 0, 0, 0.04);
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
    background: $mono3;
  }
}

.btn-pricing-btm {
  width: 80%;
  left: 10%;
  min-height: 50px;
}

.annoucement {
  display: flex;
  justify-content: center;

  &__wrapper {
    background-image: url("data:image/svg+xml,%3Csvg width='840' height='80' viewBox='0 0 840 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Crect width='840' height='80' rx='3' fill='%23F3FCF4'/%3E%3Ccircle opacity='0.1' cx='806' cy='80' r='15.5' stroke='%235E8E3E' stroke-width='5'/%3E%3Ccircle opacity='0.1' cx='636' cy='14' r='6' fill='%235E8E3E'/%3E%3Ccircle opacity='0.1' cx='137' cy='80' r='12' fill='%235E8E3E'/%3E%3Ccircle opacity='0.1' cx='-1' cy='34' r='23' stroke='%235E8E3E' stroke-width='6'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='840' height='80' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
    background-repeat: repeat;
    min-height: 80px;
    margin-top: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 26px 60px 26px 40px;
  }

  &__icon {
    margin-bottom: -7px;
    margin-right: 8px;
  }

  &__text {
    font-style: normal;
    color: $cGreen3;
    text-align: center;
  }
}
.gp-pricing {
  @mixin new-pricing-font {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
  &-action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    margin-bottom: 48px;
    &_section {
      position: relative;
      display: inline-block;
      cursor: pointer;
      &__button {
        @include new-pricing-font;
        cursor: pointer;
        color: map-get($dark-text-new, "high-contrast");
        padding: 13px 44px 13px 16px;
        background-color: map-get($light-grey, "600");
        border: 1px solid map-get($light-grey, "200");
        border-radius: 3px;
        &:hover {
          border: 1px solid map-get($dark-text-new, "high-contrast");
        }
        &:active {
          border: 1px solid map-get($primary, "300");
        }
      }
      &__icon {
        position: absolute;
        top: 13px;
        right: 16px;
        width: auto;
        height: auto;
        z-index: 1;
      }
    }
  }
  &-table {
    margin-bottom: 48px;
  }
}
.mb-68 {
  margin-bottom: 68px !important;
}
.plan-discount {
  position: relative;
  &__box {
    position: absolute;
  }

  &--professional {
    bottom: 100%;
    width: 100%;
    left: 0;

    .plan-discount {
      &__wrapper {
        width: fit-content;
      }
    }
  }

  &--advanced {
    bottom: 100%;
    left: -1px;
    width: calc(100% + 2px);
    background-color: map-get($accent-amber, "500");
    border: 1px solid map-get($accent-amber, "300");
    border-radius: $radius $radius 0px 0px;

    &__first {
      flex: 1 1 36%;
      margin-right: 6px;
    }
    &__last {
      flex: 1 1 64%;
    }
  }
}

@media (max-width: 1362px) {
  .plan-header {
    .gem {
      width: 72px;
    }
  }
}

@media (max-width: 1279px) {
  .pricing {
    padding: 100px 60px 0 60px;
    .actual-fullwidth {
      margin: 0 -60px;
      max-width: calc(100% + 120px);
    }

    .plan-header {
      padding: 24px 20px 16px 16px;
      .gem {
        width: 48px;
      }
    }

    .plan.professional {
      .plan-header {
        // padding: 33px 20px 16px 16px;
      }
    }

    .feature-container {
      padding-left: 32px;
      padding-right: 32px;
    }

    .list {
      // margin-right: -28px;
    }

    .professional {
      .plan-header {
        // .amount {
        //   font-size: 60px;
        //   line-height: 86.4px;
        // }
        // .dollar {
        //   font-size: 24px;
        //   line-height: 40px;
        // }
        // .billing-period {
        //   font-size: 24px;
        //   line-height: 40px;
        // }
      }
    }
  }
}

@media (max-width: 1118px) {
  .plan-header .info .balancer {
    /* min-height: 67px; */
  }
}

@media (max-width: 1104px) {
  .plan-header .info .balancer {
    /* min-height: 91px; */
  }
}

@media (max-width: 1023px) {
  .testimonials-masonry {
    column-count: 2;
  }
  .plan.professional {
    .feature-container {
      padding-bottom: 32px !important;
    }
  }

  .pricing {
    .plan-header {
      .gem {
        width: 100px;
      }
      .info .balancer {
        min-height: unset;
      }
    }
    .actual-fullwidth {
      padding-bottom: 60px;
    }
  }
}

@media (max-width: 767px) {
  .section-title {
    font-size: 36px;
  }
}

@media (max-width: 670px) {
  .pricing {
    padding: 60px 30px;

    .exit-btn {
      top: 0 !important;
      right: 0 !important;
      z-index: 10;
    }

    .actual-fullwidth {
      margin: 0 -30px;
      width: calc(100% + 60px);
    }
  }
  .testimonials-masonry {
    column-count: 1;
  }
}

@media (max-width: 575px) {
  .section-title {
    font-size: 32px;
  }
}

@media (max-width: 320px) {
  .pricing {
    padding: 60px 30px;

    .exit-btn {
      right: 10%;
    }
  }
}

@media (max-height: 720px) {
  // .pricing {
  //   padding-top: 60px;
  // }
}

@media (max-height: 576px) {
  .pricing {
    // padding-top: 30px;

    .exit-btn {
      top: 5px;
      right: 10px;
    }
  }
}

// Vì container có padding 12px nên padding box bên ngoài = (24px - 12px)
@media (max-width: 1024px) {
  .pricing {
    padding: 100px 12px 0 12px;
  }
  .mb-md-none {
    margin-bottom: 0 !important;
  }
  .gp-pricing-table {
    width: calc(100vw - 48px);
    // overflow: hidden;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .gp-pricing-table {
    width: 100%;
    // overflow: hidden;
  }
}
// @media screen and (min-width: 768px) and (max-width: 1024px) {
//   .gp-pricing-table {
//     width: 100%;
//     overflow: hidden;
//   }
// }
</style>
